import { GET_PORTFOLIO } from '../actionTypes'
import { Portfolio } from '../reducers/portfolio'

export const getPortfolioAction = (portfolio: Portfolio) => ({ type: GET_PORTFOLIO, payload: portfolio })
